import { useContext } from "react";
import { ProductScoresContext } from "./context";

export const useProductScoresContext = () => {
    const context = useContext(ProductScoresContext);

    if (context) {
        return context;
    }

    throw new Error(`useProductScoresContext must be used within a valid provider`);
};
